import React from 'react';
import Subtitle from '../subtitle/Subtitle';

import { Row, Col, Container } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import { css } from 'emotion';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import { LargeBusiness, htmlWidget } from '../../Constants';

function BusinessGeneralTile(props) {

    const renderContent = (content) => {
        return { __html: content };
    }
    return (

        <div className='business-general-tile mb-3'>
            <div className="business-general-tile-body">
                <a aria-label={props.cta && props.cta.ariaLabel} href={(props.cta && (props.cta.type == 'arrow' || props.cta.type == '' || props.clickable == 'Yes')) && props.cta.link}>
                    {props.image &&
                        <div>
                            {props.image &&
                                <div className="p-0">
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <img className="w-100 mb-2 top-borders shadow-none" src={props.image} alt={props.alt} />
                                    </div>
                                </div>
                            }

                            <div className='tile-content'>
                                {!props.cta && props.title && 
                                    <div>
                                        <div className={htmlWidget+' mb-0 pt-2 pl-2 pr-2 pb-0 ml-2 mr-2 three_six_titlearea card-title'} dangerouslySetInnerHTML={renderContent(props.title)} ></div>
                                        {props.subtitleOld && <div className={htmlWidget+' mb-0 pt-2 pl-2 pr-2 pb-0 ml-2 mr-2 three_six_subtitlearea'} dangerouslySetInnerHTML={renderContent(props.subtitle)} ></div>}
                                    </div>
                                    
                                }
                                {props.cta && props.title && props.cta.type != 'arrow' &&
                                    <div>
                                        <div className={htmlWidget+' mb-0 pt-2 pl-2 pr-2 pb-0 ml-2  mr-2 three_six_titlearea card-title'} dangerouslySetInnerHTML={renderContent(props.title)} ></div>
                                        {props.subtitleOld && <div className={htmlWidget+' mb-0 pt-2 pl-2 pr-2 pb-0 ml-2 mr-2 three_six_subtitlearea'} dangerouslySetInnerHTML={renderContent(props.subtitle)} ></div>}
                                    </div>
                                }
                                {props.cta && props.cta.type == 'arrow' &&
                                    <div className="d-flex">
                                        <div className={htmlWidget+' mb-0 pt-2 pl-2 pr-2 pb-0 mr-1 ml-2 three_six_titlearea card-title'} dangerouslySetInnerHTML={renderContent(props.title)} ></div>
                                        {props.subtitleOld && <div className={htmlWidget+' mb-0 pt-2 pl-2 pr-2 pb-0 mr-1 ml-2 three_six_subtitlearea'} dangerouslySetInnerHTML={renderContent(props.subtitle)} ></div>}
                                        <div className="mt-2">
                                            <div className={'arrow_cta float-right mb-2 mr-3 ' + (css`background-image: url(${(props.arrow) ? props.arrow.path : ''}); &:hover, &:focus, &:focus-within, &:active {background-image: url(${(props.arrowHover) ? props.arrowHover.path : ''}) !important;}`)} id={props.id}></div>
                                        </div>
                                    </div>
                                }
                                {props.text &&
                                    <Subtitle className='eir-text justify-content-center ml-2  mr-3 three_six_textarea pl-2 pr-2 text-body business-card-text' text={props.text} />
                                }

                            </div>
                        </div>
                    }
                </a>
            </div>
            {props.cta && props.cta.type != 'arrow' &&
                <div className={((props.ctaAlignment == 'centre') ? 'd-flex justify-content-center align-items-center' : (isMobileOnly) ? 'ml-3' : 'ml-4')+ (LargeBusiness.isLBSite? " cta-padding " : "")}>
                    <EirButton  {...props.cta} databundlecode={props.id}
                        outline={true}
                        className={"mt-3 float-left js-prequal-modal-btn cta_threesix ls-0 " + ((props.cta.type == 'button') ? "eir-text-secondary p-2 " + (css`border-color: ${props.ctaOutline} !important; background:${props.ctaBackground} !important; color: ${props.ctaFont} !important ; &:hover, &:focus, &:focus-within, &:active {background: ${props.ctaBackgroundHover} !important;border-color: ${props.ctaOutlineHover} !important; color: ${props.ctaFontHover}!important;`) : "link_threesix " + (css`color: ${props.ctaFont} !important;`))}
                    />
                </div>
            }


        </div>

    )
}
export default BusinessGeneralTile;